"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../../Utilities");
var Styling_1 = require("../../../Styling");
exports.getClassNames = Utilities_1.memoizeFunction(function (styles, disabled, expanded, checked) {
    return {
        root: Styling_1.mergeStyles(styles.splitButtonMenuButton, expanded && [
            styles.splitButtonMenuButtonExpanded
        ], disabled && [
            styles.splitButtonMenuButtonDisabled
        ], checked && [
            styles.splitButtonMenuButtonChecked
        ]),
        icon: (disabled ? Styling_1.mergeStyles(styles.splitButtonMenuIcon, styles.splitButtonMenuIconDisabled) : styles.splitButtonMenuIcon),
        flexContainer: styles.splitButtonFlexContainer,
        divider: styles.splitButtonDivider
    };
});
//# sourceMappingURL=SplitButton.classNames.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/Button/SplitButton/SplitButton.classNames.js
// module id = 383
// module chunks = 0